import { GlobalClassInstance } from "@commoncore/constants/GlobalClass";
import { ActiveRepo } from "@commoncore/services/universal.service";
import { AppEvents } from "@commoncore/utils/app-events";
import { ENV_CONSTANTS } from "@env-properties/environment";
import { IndexedDBModule } from "@mainrepo/app/core/database/IndexedDBManager";

declare var jQuery: any;
declare var $:any;


/*

REASON FOR USING A SEPERATE CLASS FOR VIRTUAL SCROLLING:

1. Multiselect callbacks gives the objects list of the objects which are only present in the DOM. As in virtual scrolling, when an object moves out of view port it is removed from the DOM and reattached on revisit.
2. In the existing MultiSelectUtil.ts, each time an object is selected, selected nodes list is emptied and repopulating the objects we get from the multiselect callback.
3. As in virtual scrolling not all the data is present in the DOM, we are not emptying the selected nodes and keep on adding the objects to the selected nodes list and using a Set() to remove duplicates.
4. Current Multi select, only gives the list of objects which are selected, it does not give the list objects which are deselected. So, modified the multiselect.js when virtual grid is enabled we get the list of deselected objects as well.
5. For shift key selection in multi select only works on the objects present in DOM, in Virtual Scrolling we need the object keys of the starting object and ending object, so added a custom object in the callback to get the startobject and endobject.
6. custom object in the callback is also added for the scenario where, selection is enabled, and user does a right click on the unselected object, for such case, we are emptying the selected nodes array and populating it with current selected object.



NOTE: We are avoiding jQuery.each(), as this is degrading the performance and instead using $(event.target).closest(itemClassName).attr('id'); to fetch the id of the selected object.
With jQuery.each(), on every object selection we get the list of all the selected objects which is not required. So, it was looping over the already selected objects along with the current selected object.
*/

export class VirtualMultiSelectLibrary {
  universalService: any;
  contextMenuService: any;
  loggerService: any;
  dataArray:any = [];
  objectsList:any = [];
  key = "";
  router:any;
  db: IndexedDBModule;
  shareAccessService:any;
  static singleInstance:any = null;
  recalculateHeightService:any;
  public listService:any;
    constructor(public globalService){
      this.setEnvObjects(globalService);
      var self = this;
      AppEvents.multiSelectEvent.subscribe(response=>{
        if(response["initiator"] == "virtual-grid" || response["initiator"] == "virtual-justified"){
          self.dataArray = response["dataArray"];
          self.key = response["key"];
          this.createFlatListOfObjects(response["key"]);
        }
      })
      document.addEventListener('long-press', function(e) {
        self.handleLongPressEvent();
      });
    }

    setEnvObjects(globalService){
      this.universalService = globalService.getUniversalServiceRef();
      this.contextMenuService = globalService.getContextMenuServiceRef();
      this.loggerService = globalService.getLoggerServiceRef();
      this.db = IndexedDBModule.getInstance(globalService);
      this.router = globalService.getRouterRef();
      this.shareAccessService = this.globalService.getShareAccessServiceRef();
      this.recalculateHeightService = this.globalService.getContainerHeightCalculatorService();
      this.listService = globalService.getListServiceRef();
    }

  bindMultiSelectLibrary(itemContainer, activeItemClassName, itemClassName, isGridView,virtualGridEnabled,enableSingleSelect) {
  
    let universalServiceRef = this.universalService;
    let classRef = this;
    var contextMenuRef = this.contextMenuService;
    jQuery(itemContainer).unbind().multiSelect({
      actcls: activeItemClassName,
      selector: itemClassName,
      isGridView: isGridView,
      virtualGridEnabled: virtualGridEnabled,
      enableSingleSelect : enableSingleSelect,
      callback: function(items, isSelectAll,deSelectedList,customObject) { 
          if(universalServiceRef.showPreview || universalServiceRef.checkIfAnyModalIsOpen() || !universalServiceRef.virtualGridEnabled) return;
          var objId;
          universalServiceRef.showAutoSuggestion = false;
          universalServiceRef.isHorizontalRecentFileAccessedForPreview = false;
          universalServiceRef.hideEditAlbumDescBox = true;
          universalServiceRef.hideEditAlbumNameBox = true;
          if(isSelectAll){
            var result = classRef.createFlatListOfObjects(classRef.key);
            universalServiceRef.selectedNodes = result;
            universalServiceRef.openMoreOptions = false;
          }else{
            objId = $(event.target).closest(itemClassName).attr('id');
            var object = "";
            object = classRef.getObjectMetadata(objId);
            if(customObject && customObject["selectOnlyCurrentObject"]){
              universalServiceRef.selectedNodes = [];
            }
            let objectExists = universalServiceRef.selectedNodes.some(obj => obj.objectKey == object["objectKey"]);
            if(!objectExists){
              universalServiceRef.selectedNodes.push(object);
            }
            // universalServiceRef.selectedNodes = Array.from(new Set(universalServiceRef.selectedNodes)); 
            universalServiceRef.openMoreOptions = false;
            let deSelectedNodes = [];
            deSelectedList.map((index, item) => {
              objId = jQuery(item).attr("id");
              let object = classRef.getObjectMetadata(objId);
              deSelectedNodes.push(object);
              universalServiceRef.openMoreOptions = false;
            });

            deSelectedNodes.map(node=>{
              let findObject = universalServiceRef.selectedNodes.find(obj=> obj["objectKey"] == node["objectKey"])
              if(findObject){
                let index = universalServiceRef.selectedNodes.indexOf(findObject)
                universalServiceRef.selectedNodes.splice(index,1);
              }
            })
            AppEvents.virtualDOMObservable.next({"saveSelectedObjects":true,"shiftKey":customObject})
          }
          if(universalServiceRef.selectedNodes.length>0){
            
            contextMenuRef.decideContextMenuItems();
          }
          
          if(universalServiceRef.selectedNodes.length == 0) {
            universalServiceRef.selectedNodes = [];
            universalServiceRef.showTopMenu = false;
            universalServiceRef.hideTopMenuOptions();
            if(universalServiceRef.showTopMenu == false){
              // jQuery(".left-icon-set .left-icon-set").hide();
              jQuery( ".left-icon-set .NeueSort" ).prop( "disabled", false );
              jQuery( ".left-icon-set .NeueA-Z" ).prop( "disabled", false );
              jQuery( ".left-icon-set .NeueListView" ).prop( "disabled", false );
            }
            universalServiceRef.showContextMenu = false;
            if(!universalServiceRef.selectedFile) {
              universalServiceRef.showMobOptionMenu = false;
            }
            universalServiceRef.showFileInfo = false;
            universalServiceRef.isDesktopSelectionModeOn = false;
            $(".highlight-recent-item").removeClass("highlight-recent-item");
            contextMenuRef.decideContextMenuItems()
            setTimeout(() => {
              // classRef.recalculateHeightService.sendRecalculateEventToComponents(true);
            }, 10);
            return false;
          }

          if(universalServiceRef.showTopMenu == true || universalServiceRef.emptyFolder == true){
            jQuery( ".left-icon-set .NeueSort" ).prop( "disabled", true );
            jQuery( ".left-icon-set .NeueA-Z" ).prop( "disabled", true );
            jQuery( ".left-icon-set .NeueListView" ).prop( "disabled", true );
          }

          if(universalServiceRef.selectedNodes.length == 1) {
            universalServiceRef.selectedFile = universalServiceRef.selectedNodes[0];            
            if(universalServiceRef.isMobileDevice) {
              if(event != undefined && jQuery(event.target).attr("class") != undefined && jQuery(event.target).attr("class").indexOf("NeueMore_Options") != -1) {
                universalServiceRef.showMobOptionMenu = true;
              }
            }

            $(window).on('hidden.bs.modal', function() { 
              universalServiceRef.selectedNodes = [];
              $('.listItem').removeClass('list_info');
              $('.gridItem').removeClass('grid_info');
              
              universalServiceRef.showMobOptionMenu = false;
            });
            setTimeout(() => {
              // classRef.recalculateHeightService.sendRecalculateEventToComponents(true);
            }, 10);
          }

          if(universalServiceRef.showFileInfo){
            universalServiceRef.showFileInfo = false;
          }

          if(universalServiceRef.selectedNodes.length > 1){
            universalServiceRef.showFileInfo = false;

            if(!universalServiceRef.isMobileDevice) {
              universalServiceRef.isDesktopSelectionModeOn = true;
            }
          }
          universalServiceRef.isFolderPresent(); 
          universalServiceRef.showTopMenu = true; 
          universalServiceRef.showTopMenuOptions();
          jQuery("#customContextMenu").hide();
          universalServiceRef.subject.next(universalServiceRef.selectedNodes.length);
          if(universalServiceRef.selectedNodes.length === 1) {
            universalServiceRef.openMoreOptions = false;
            if(universalServiceRef.selectedNodes[0].horizontalPanelItem == false || universalServiceRef.selectedNodes[0].horizontalPanelItem == undefined){
              if(event.type == 'contextmenu') {
                
                contextMenuRef.showCustomContextMenu(event); 
                return false;
              }
            }else{
              universalServiceRef.showTopMenu = false; 
              universalServiceRef.hideTopMenuOptions();  
            }
          }
      }
    });
  }
  bindMultiSelectUIevent(itemContainer, itemClassName) {
    let classRef = this;
    var universalServiceRef = this.universalService;    
    var contextMenuRef = this.contextMenuService;
    jQuery(itemContainer).off().on('click', itemClassName, function(e) {
        if ((!universalServiceRef.isDesktopSelectionModeOn && !universalServiceRef.mobileSelectionModeOn) && universalServiceRef.selectedNodes.length == 1 && universalServiceRef.selectedNodes[0].objectType != 'FR' && !$('#add-to-jiocloud-modal').is(':visible')) {
     
          if(classRef.universalService.isUserOnSharedLinkByMe || universalServiceRef.currentTab == "Trash" || universalServiceRef.currentTab == "tftrash"){
            return;
          }
          if(universalServiceRef.isHorizontalRecentFileAccessedForPreview) {
            universalServiceRef.recentFilesDataPreview = true;
          }
          universalServiceRef.openPreview(universalServiceRef.selectedNodes[0]);
          classRef.db.clearStore("RecentFilesMetadata");  // refresh recent files in all files to latest previewed file

          setTimeout(()=>{
            
            contextMenuRef.decideContextMenuItems();
          },500)
          
        }
        this.showContextMenu = false;
        jQuery("#customContextMenu").hide();
    });
  
    $(itemContainer).on('contextmenu', itemClassName, function(e) {   
      if(universalServiceRef.selectedNodes.length != 0 && (universalServiceRef.selectedNodes[0].horizontalPanelItem == false || universalServiceRef.selectedNodes[0].horizontalPanelItem == undefined)){
        
        contextMenuRef.showCustomContextMenu(e);   
        universalServiceRef.showTopMenu = true; 
        universalServiceRef.showTopMenuOptions();
      }else{
        universalServiceRef.openMoreOptions = false;
        universalServiceRef.showTopMenu = false; 
        universalServiceRef.hideTopMenuOptions();
      } 
    });
  }

  getObjectMetadata(id){
    var data;
    data = this.objectsList.find(obj=> obj["objectKey"] == id);
    return data?data:(this.objectsList.length == 0 ? undefined : {});
  }


  getAllObjects(){
    const result = this.dataArray.flatMap(month => month["objects"] ? month["objects"] : month)
    return result;
  }


  createFlatListOfObjects(key){
    this.objectsList = this.dataArray.flatMap(row => row[key] ? row[key] : row);
    return this.objectsList;
  }

  handleLongPressEvent() {
    let universalServiceRef = this.universalService;
    if(!universalServiceRef.isMobileDevice) return;
    $(".highlight-recent-item").removeClass("highlight-recent-item");
    universalServiceRef.selectedNodes =[];
    universalServiceRef.openMoreOptions = false;
    universalServiceRef.showTopMenu = false; 
    universalServiceRef.hideTopMenuOptions();
  }
}


